import { Value } from "../value.js";
/**
 * @internal
 */
export class BasicShape extends Value {
    _kind;
    constructor(kind, hasCalculation) {
        super("basic-shape", hasCalculation);
        this._kind = kind;
    }
    get kind() {
        return this._kind;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            kind: this._kind,
        };
    }
}
//# sourceMappingURL=basic-shape.js.map